<template>
  <el-dialog
    :title="$tt('画布快捷键')"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    custom-class="canvas-shortcut-dialog"
    @close="handleClose"
  >
    <div v-for="group in shortcutGroups" :key="group.title" class="shortcut-group">
      <div class="shortcut-group-title">{{ $tt(group.title) }}</div>
      <div
        v-for="(item, index) in group.items"
        :key="group.title + index"
        class="shortcut-row"
      >
        <span class="shortcut-keys">{{ item.keys }}</span>
        <span class="shortcut-desc">{{ $tt(item.desc) }}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="dialogVisible = false">{{ $tt("知道了") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { CANVAS_SHORTCUT_GROUPS } from "@/utils/canvasShortcutHelp";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shortcutGroups: CANVAS_SHORTCUT_GROUPS,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss">
.canvas-shortcut-dialog {
  .el-dialog__body {
    padding-top: 8px;
    max-height: 60vh;
    overflow-y: auto;
  }
  .shortcut-group + .shortcut-group {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
  }
  .shortcut-group-title {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
  }
  .shortcut-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 6px 0;
    font-size: 13px;
    line-height: 1.5;
  }
  .shortcut-keys {
    flex-shrink: 0;
    min-width: 108px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    color: #606266;
    font-family: Consolas, Monaco, monospace;
    font-size: 12px;
  }
  .shortcut-desc {
    color: #606266;
  }
}
</style>
